var _excluded = ["block", "size", "name", "as"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import BlankButton from "@xo-union/component-blank-button";
import InteractiveIcon from "../InteractiveIcon/index.js";

/**
 * Render an interactive icon as a button. Use this component when the interaction will leave the user
 * in the same url.
 *
 * Passes ref to underlying button
 */
var IconButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var block = _ref.block,
    size = _ref.size,
    name = _ref.name,
    as = _ref.as,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(InteractiveIcon, _extends({
    ref: ref,
    name: name,
    as: as,
    block: block,
    size: size
  }, rest));
});
IconButton.propTypes = {
  /**
   * Icon name
   */
  name: PropTypes.string.isRequired,
  /**
   * Component to render
   */
  as: PropTypes.elementType,
  /**
   * To determine if icon should have a block display
   */
  block: PropTypes.bool,
  /**
   * Size class
   */
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
};
IconButton.defaultProps = {
  block: false,
  size: null,
  as: BlankButton
};
IconButton.displayName = 'IconButton';
export default IconButton;